"use strict";
$(function(){
// Feather Icon Js
    feather.replace();

// Mean Menu
    jQuery(".mean-menu").meanmenu({
        meanMenuOpen: "<span></span><span></span><span></span>",
        meanScreenWidth: "991"
    });

// Magnific Popup
    $(".popup-youtube").magnificPopup({
        disableOn: 320,
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });

// Header Sticky
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 120) {
            $("#header").addClass("is-sticky");
        } else {
            $("#header").removeClass("is-sticky");
        }
    });
    let headerElement = document.querySelector(".headroom");
    if (headerElement) {
        let headroom = new Headroom(headerElement, {
            offset: 100
        });
        headroom.init();
    }

// Popup Gallery
    $(".popup-btn").magnificPopup({
        type: "image",
        gallery: {
            enabled: true
        }
    });

// Works Slides
    var owl = $(".works-slides");
    owl.owlCarousel({
        loop: true,
        nav: false,
        autoplay: true,
        dots: false,
        rtl:window.rtlVal,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            1200: {
                items: 3
            },
            1500: {
                items: 4
            }
        }
    });

// Boxes Slides
    var owl = $(".boxes-slides");
    owl.owlCarousel({
        loop: true,
        nav: false,
        autoplay: true,
        dots: false,
        rtl:window.rtlVal,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            1200: {
                items: 4
            }
        }
    });

// Testimonials Slides
    var owl = $(".testimonials-slides");
    owl.owlCarousel({
        loop: false,
        nav: false,
        dots: true,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        items: 1
    });

// Team Slides
    var owl = $(".team-slides");
    owl.owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            1200: {
                items: 4
            },
            1500: {
                items: 5
            }
        }
    });

// Feedback Carousel
    var $imagesSlider = $(".feedback-slides .client-feedback>div"),
        $thumbnailsSlider = $(".client-thumbnails>div");
// images options
    $imagesSlider.slick({
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: "linear",
        fade: true,
        autoplay: true,
        draggable: true,
        asNavFor: ".client-thumbnails>div",
        prevArrow: ".client-feedback .prev-arrow",
        nextArrow: ".client-feedback .next-arrow"
    });
// Thumbnails options
    $thumbnailsSlider.slick({
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        cssEase: "linear",
        autoplay: true,
        centerMode: true,
        draggable: false,
        focusOnSelect: true,
        asNavFor: ".feedback-slides .client-feedback>div",
        prevArrow: ".client-thumbnails .prev-arrow",
        nextArrow: ".client-thumbnails .next-arrow"
    });

// Go to Top
    $(function () {
        //Scroll event
        $(window).on("scroll", function () {
            var scrolled = $(window).scrollTop();
            if (scrolled > 300) $(".go-top").fadeIn("slow");
            if (scrolled < 300) $(".go-top").fadeOut("slow");
        });
        //Click event
        $(".go-top").on("click", function () {
            $("html, body").animate({
                    scrollTop: "0"
                },
                500
            );
        });

        $(".create-account-btn").on("click", function () {
            $("html, body").animate({
                    scrollTop: "0"
                },
                500
            );
        });
    });

// FAQ Accordion
    $(function () {
        $(".accordion")
            .find(".accordion-title")
            .on("click", function () {
                // Adds Active Class
                $(this).toggleClass("active");
                // Expand or Collapse This Panel
                $(this)
                    .next()
                    .slideToggle("fast");
                // Hide The Other Panels
                $(".accordion-content")
                    .not($(this).next())
                    .slideUp("fast");
                // Removes Active Class From Other Titles
                $(".accordion-title")
                    .not($(this))
                    .removeClass("active");
            });
    });

// Tabs
    $("#tabs li").on("click", function () {
        var tab = $(this).attr("id");
        if ($(this).hasClass("inactive")) {
            $(this).removeClass("inactive");
            $(this).addClass("active");
            $(this)
                .siblings()
                .removeClass("active")
                .addClass("inactive");
            $("#" + tab + "_content").addClass("show");
            $("#" + tab + "_content")
                .siblings("div")
                .removeClass("show");
        }
    });

// Count Time
    function makeTimer() {
        var endTime = new Date("August 19, 2020 17:00:00 PDT");
        var endTime = Date.parse(endTime) / 1000;
        var now = new Date();
        var now = Date.parse(now) / 1000;
        var timeLeft = endTime - now;
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor((timeLeft - days * 86400) / 3600);
        var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
        var seconds = Math.floor(
            timeLeft - days * 86400 - hours * 3600 - minutes * 60
        );
        if (hours < "10") {
            hours = "0" + hours;
        }
        if (minutes < "10") {
            minutes = "0" + minutes;
        }
        if (seconds < "10") {
            seconds = "0" + seconds;
        }
        $("#days").html(days + "<span>Days</span>");
        $("#hours").html(hours + "<span>Hours</span>");
        $("#minutes").html(minutes + "<span>Minutes</span>");
        $("#seconds").html(seconds + "<span>Seconds</span>");
    }
    setInterval(function () {
        makeTimer();
    }, 1000);

// Products Details Image Slider
    $(".slickslide").slick({
        dots: true,
        speed: 500,
        fade: false,
        slide: "li",
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: false,
        nextArrow: false,
        responsive: [{
            breakpoint: 1200,
            settings: {
                arrows: false,
                centerMode: false,
                centerPadding: "40px",
                variableWidth: false,
                slidesToShow: 1,
                dots: true
            }
        }],
        customPaging: function (slider, i) {
            return (
                '<button class="tab">' +
                $(".slick-thumbs li:nth-child(" + (i + 1) + ")").html() +
                "</button>"
            );
        }
    });

// Input Plus & Minus Number JS
    $(".input-counter").each(function () {
        var spinner = jQuery(this),
            input = spinner.find('input[type="text"]'),
            btnUp = spinner.find(".plus-btn"),
            btnDown = spinner.find(".minus-btn"),
            min = input.attr("min"),
            max = input.attr("max");

        btnUp.on("click", function () {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });
        btnDown.on("click", function () {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });
    });

// Odometer JS
    $(".odometer").appear(function (e) {
        var odo = $(".odometer");
        odo.each(function () {
            var countNumber = $(this).attr("data-count");
            $(this).html(countNumber);
        });
    });

// Partner Slides
    var owl = $(".partner-slides");
    owl.owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive: {
            0: {
                items: 2
            },
            576: {
                items: 4
            },
            768: {
                items: 4
            },
            1200: {
                items: 6
            }
        }
    });

// Tabs JS
    (function ($) {
        $(".tab ul.tabs")
            .addClass("active")
            .find("> li:eq(0)")
            .addClass("current");
        $(".tab ul.tabs li a").on("click", function (g) {
            var tab = $(this).closest(".tab"),
                index = $(this)
                    .closest("li")
                    .index();
            tab.find("ul.tabs > li").removeClass("current");
            $(this)
                .closest("li")
                .addClass("current");
            tab.find(".tab_content")
                .find("div.tabs_item")
                .not("div.tabs_item:eq(" + index + ")")
                .slideUp();
            tab.find(".tab_content")
                .find("div.tabs_item:eq(" + index + ")")
                .slideDown();
            g.preventDefault();
        });
    })(jQuery);

// ML Feedback Slides
    var owl = $(".ml-feedback-slides");
    owl.owlCarousel({
        loop: false,
        nav: false,
        dots: true,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        items: 1,
        animateOut: "fadeOut"
    });

// ML Projects Slides
    var owl = $(".ml-projects-slides");
    owl.owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        margin: 10,
        autoplayTimeout: 5000,
        responsive: {
            0: {
                items: 2
            },
            576: {
                items: 2
            },
            767: {
                items: 3
            },
            1024: {
                items: 4
            },
            1300: {
                items: 5
            }
        }
    });

// ML Main Slides
    var owl = $(".ml-main-slides");
    owl.owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        margin: 0,
        autoplayTimeout: 5000,

        items : 1,
        singleItem:true,
        stagePadding: 0,
    });

// ML Main Slides
    var owl = $(".ml-ads-slides");
    owl.owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        margin: 0,
        autoplayTimeout: 5000,

        items : 1,
        singleItem:true,
        stagePadding: 0,
    });

    $(window).on("load", function () {
        // WOW JS
        if ($(".wow").length) {
            var wow = new WOW({
                boxClass: "wow", // animated element css class (default is wow)
                animateClass: "animated", // animation css class (default is animated)
                offset: 20, // distance to the element when triggering the animation (default is 0)
                mobile: true, // trigger animations on mobile devices (default is true)
                live: true // act on asynchronously loaded content (default is true)
            });
            wow.init();
        }
    });

// Preloader Area
    jQuery(window).on("load", function () {
        $(".preloader").fadeOut();
    });

// iman aghapour

// forget pass
    $(".forget-pass").on("click", function () {
        $("#my-login-modal").modal("hide");
        setTimeout(function () {
            $("#my-login-modal2").modal("show");
        }, 305);
    });
// back forget pass
    $(".come-back").on("click", function () {
        $("#my-login-modal2").modal("hide");
        setTimeout(function () {
            $("#my-login-modal").modal("show");
        }, 305);
    });
// back forget pass
// forget pass

// modal login tab
    $(".h-signup").on("click", function () {
        $("#signup-click").trigger("click");
    });

    $(".h-signin").on("click", function () {
        $("#signin-click").trigger("click");
    });
// modal login tab

//dashboard tab

    $(".tab-control .extra-filters").click(function (e) {
        $(".tab-control-box").fadeToggle(200);
        e.stopPropagation();
    });

    $(".tab-control-box").click(function (e) {
        e.stopPropagation();
    });

    $("body").click(function () {
        $(".tab-control-box").fadeOut(300);
    });

    $(".chTab").click(function (e) {
        e.preventDefault();
        $(".chTab").removeClass("tab-header-active");
        $(this).addClass("tab-header-active");
        $(".tab--content")
            .find(".tab-content-ch")
            .hide();
        $(".tab-content-" + $(this).attr("data-t")).fadeIn(300);
    });
//dashboard tab

// profile edit name
    $('.lookingFor .lookingFor-iam i').click(function () {
        $('.lookingFor .lookingFor-iam i').removeClass('lookingFor-active');
        $(this).addClass('lookingFor-active');
    })

    $('.lookingFor .lookingFor-seeking i').click(function () {
        $('.lookingFor .lookingFor-seeking i').removeClass('lookingFor-active');
        $(this).addClass('lookingFor-active');
    })
// profile edit name

// profile edit Interests
    $('#pp-edit-Interests .interests-select li').click(function () {
        $(this).toggleClass('interests-select-active');
    })
// profile edit Interests

// dashboard res menu
    $(".dash-res-menu i").click(function (e) {
        $(".dash-res-menu-box").fadeToggle(200);
        $(".dash-user-profile-box").hide(200);
        e.stopPropagation();
    });

    $(".dash-res-menu-box").click(function (e) {
        e.stopPropagation();
    });

    $("body").click(function () {
        $(".dash-res-menu-box").fadeOut(300);
    });
// dashboard res menu

// dashboard res menu
    $(".dash-user-profile img").click(function (e) {
        $(".dash-user-profile-box").fadeToggle(200);
        $(".dash-res-menu-box").hide(200);
        e.stopPropagation();
    });

    $(".dash-user-profile-box").click(function (e) {
        e.stopPropagation();
    });

    $("body").click(function () {
        $(".dash-user-profile-box").fadeOut(300);
    });
// dashboard res menu

// select payment
    $('.allPayment .allPayment-logos div').click(function () {
        $('.allPayment .allPayment-logos div').removeClass('select-Payment-logos');
        $(this).addClass('select-Payment-logos');
    })
// select payment

// fix contact
    $('.cd-popup-trigger').on('click', function (event) {
        event.preventDefault();
        $('.cd-popup').addClass('is-visible');
    });

//close popup
    $('.cd-popup').on('click', function (event) {
        if ($(event.target).is('.cd-popup-close') || $(event.target).is('.cd-popup')) {
            event.preventDefault();
            $(this).removeClass('is-visible');
        }
    });
//close popup when clicking the esc keyboard button
    $(document).keyup(function (event) {
        if (event.which == '27') {
            $('.cd-popup').removeClass('is-visible');
        }
    });
// fix contact

// owl-ssd-details
    var owl = $(".owl-ssd-details");
    owl.owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        rtl:window.rtlVal,
        autoplay: true,
        smartSpeed: 1000,
        margin: 0,
        autoplayTimeout: 5000,
        items: 1,
        navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    });

// iman aghapour

    var currentTab = 0;
    var skipShow = 0;

//showTab(currentTab); // Display the current tab
// showSkip(currentTab);
//skipTab(skipShow); // Display the current tab

    function showTab(n) {
        // This function will display the specified tab of the form ...
        var x = document.getElementsByClassName("tab");
        x[n].style.display = "block";
        // ... and fix the Previous/Next buttons:
        if (n == 0) {
            document.getElementById("prevBtn").style.display = "none";
            document.getElementById("skipBtn").style.display = "none";
        } else {
            document.getElementById("prevBtn").style.display = "inline";
            document.getElementById("skipBtn").style.display = "inline";
        }
        if (n == x.length - 1) {
            document.getElementById("nextBtn").innerHTML = "Complete";
        } else {
            document.getElementById("nextBtn").innerHTML = "Next";
        }
        // ... and run a function that displays the correct step indicator:
        fixStepIndicator(n);
    }

    function nextPrev(n) {
        // This function will figure out which tab to display
        var x = document.getElementsByClassName("tab");
        // Exit the function if any field in the current tab is invalid:
        if (n == 1 && !validateForm()) return false;
        // Hide the current tab:
        x[currentTab].style.display = "none";
        // Increase or decrease the current tab by 1:
        currentTab = currentTab + n;
        // if you have reached the end of the form... :
        if (currentTab >= x.length) {
            //...the form gets submitted:
            document.etElementsByClassName("regForm").submit();
            return false;
        }
        // Otherwise, display the correct tab:
        showTab(currentTab);
    }

    function validateForm() {
        // This function deals with validation of the form fields
        var x,
            y,
            i,
            valid = true;
        x = document.getElementsByClassName("tab");
        y = x[currentTab].getElementsByClassName("inputimport");
        // A loop that checks every input field in the current tab:
        for (i = 0; i < y.length; i++) {
            // If a field is empty...
            if (y[i].value == "") {
                // add an "invalid" class to the field:
                y[i].className += " invalid";
                // and set the current valid status to false:
                valid = false;
            }
        }
        // If the valid status is true, mark the step as finished and valid:
        if (valid) {
            document.getElementsByClassName("step")[currentTab].className +=
                " finish";
        }
        return valid; // return the valid status
    }

    function fixStepIndicator(n) {
        // This function removes the "active" class of all steps...
        var i,
            x = document.getElementsByClassName("step");
        for (i = 0; i < x.length; i++) {
            x[i].className = x[i].className.replace(" active", "");
        }
        //... and adds the "active" class to the current step:
        x[n].className += " active";
    }
});
